// src/styles/theme.ts
export const theme = {
    colors: {
      blue1: '#0f1113',
      blue2: '#17191c',
      blue3: '#212326',
      blue4: '#282a2d',
      blue5: '#2f3135',
      blue6: '#383b3e',
      blue7: '#46484c',
      blue8: '#5f6165',
      blue9: '#fafcff',
      blue10: '#f1f3f6',
      blue11: '#b1b4b8',
      blue12: '#eceef1',
    }
  };
  
  export type Theme = typeof theme;